import { useParams } from 'react-router-dom';
import MerchantDetail from '../features/merchants/MerchantDetail';

export const MerchantDetailPage = () => {
  const { id } = useParams<{ id: string }>();
  return <MerchantDetail id={id!} />;
};
